// 車両表示色のパレット（backend VehicleColorPalette::COLORS と同一の12色）。
export const DEFAULT_VEHICLE_COLORS = [
  '#3b82f6', '#ef4444', '#10b981', '#f59e0b', '#8b5cf6', '#ec4899',
  '#06b6d4', '#84cc16', '#f97316', '#6366f1', '#14b8a6', '#e11d48',
];

// カスタム色があればそれ。無ければ並び順 index のパレット色にフォールバック。常に色を返す。
// map（buildMapVehicleRoutes）と左リスト色バーで共用し、両者の色を一致させる。
export function resolveVehicleColor(truckColor: string | null | undefined, orderIndex: number): string {
  return truckColor ?? DEFAULT_VEHICLE_COLORS[orderIndex % DEFAULT_VEHICLE_COLORS.length];
}
